import React from 'react';
import { automationIds } from '../../../constants/automationIds';
import { renderDate } from '../../../helpers/date';
import MessageIconButton from '../../../components/shared/notifications/MessageIconButton';
import Label from '../../../components/shared/Label';
import Color from '../../../enums/color';
export const columns = [
    {
        name: 'NOTIFICATIONS.COLUMN.CLIENT',
        dataIndex: 'clientName',
        key: 'clientName',
        width: '15%',
        automationId: automationIds.TABLE_HEADER.NOTIFICATION_CLIENT,
        render: (value, { isRead }) => <Label title={value} color={isRead ? Color.Grey172 : Color.Black}/>
    },
    {
        name: 'NOTIFICATIONS.COLUMN.COMPANY',
        dataIndex: 'companyName',
        key: 'companyName',
        width: '15%',
        automationId: automationIds.TABLE_HEADER.NOTIFICATION_COMPANY,
        render: (value, { isRead }) => <Label title={value} color={isRead ? Color.Grey172 : Color.Black}/>
    },
    {
        name: 'NOTIFICATIONS.COLUMN.NOTIFICATION',
        dataIndex: 'message',
        key: 'message',
        width: '50%',
        automationId: automationIds.TABLE_HEADER.NOTIFICATION,
        render: (value, { isRead }) => <Label title={value} color={isRead ? Color.Grey172 : Color.Black}/>
    },
    {
        name: 'NOTIFICATIONS.COLUMN.DATE',
        dataIndex: 'dateCreated',
        sortable: true,
        key: 'dateCreated',
        width: '10%',
        automationId: automationIds.TABLE_HEADER.NOTIFICATION_DATE,
        render: (value, { isRead }) => <Label title={renderDate(value)} color={isRead ? Color.Grey172 : Color.Black}/>
    },
    {
        name: 'NOTIFICATIONS.COLUMN.READ',
        dataIndex: 'isRead',
        key: 'isRead',
        width: '10%',
        align: 'center',
        automationId: automationIds.TABLE_HEADER.NOTIFICATION_READ,
        render: (_, record) => <MessageIconButton notificationId={record.id} isRead={record.isRead}/>
    }
];
